import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { publicHttpClient } from '../httpClient';
import { linkApiPath } from './apiPath';

const GetLinkCouponRequestParamsSchema = z
  .object({
    couponNo: z.number().int(),
  })
  .describe('GetLinkCouponRequestParamsSchema');

type GetLinkCouponRequestParams = z.infer<typeof GetLinkCouponRequestParamsSchema>;

const GetLinkCouponResponseDataSchema = z
  .object({
    shortLink: z.string(),
  })
  .describe('GetLinkCouponResponseDataSchema');

type GetLinkCouponResponseData = z.infer<typeof GetLinkCouponResponseDataSchema>;

type GetLinkCouponResponse = MusinsaStandardResponse<GetLinkCouponResponseData>;

export const getLinkCoupon = ({ couponNo }: GetLinkCouponRequestParams) =>
  executeStandardRequest(() =>
    publicHttpClient.get<GetLinkCouponResponse>(linkApiPath.getLinkCoupon(couponNo)),
  );
